// Use this parameter to set a sessionStorage var at Login.tsx
export const POSTHOG_PLAYWRIGHT_DISABLED_PARAM = 'disablePostHog';
